export function getParentOrShadowHost(element) {
  return element.parentElement || element.getRootNode().host;
}